import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";
import { Camera, Check } from "lucide-react";

export default function MediaDay() {
  const [days, setDays] = useState([]);
  useEffect(() => { api.get("/media-days").then((r) => setDays(r.data)).catch(() => {}); }, []);
  const packages = days[0]?.packages || [];

  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
          <span className="eyebrow text-exploration">H.E.A. Media</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Media Day</h1>
          <p className="mt-4 max-w-xl text-white/70">Professional portrait sessions for H.E.A. students. Choose a package, pick a time slot, and we'll deliver a beautiful edited gallery.</p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 lg:px-8">
        {days[0] && (
          <div className="mb-10 rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex items-center gap-2 font-display font-semibold text-navy"><Camera className="h-5 w-5 text-brandblue" />{days[0].title}</div>
            <p className="mt-1 text-sm text-slateBrand">{new Date(days[0].date).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })} • {days[0].location}</p>
          </div>
        )}
        <div className="grid gap-8 md:grid-cols-3">
          {packages.map((p, i) => (
            <div key={p.name} data-testid={`media-package-${p.name.toLowerCase()}`} className={`rounded-3xl border bg-white p-8 ${i === 2 ? "border-brandblue shadow-lg" : "border-slate-200"}`}>
              <h3 className="font-display text-xl font-bold text-navy">{p.name}</h3>
              <div className="mt-3 font-display text-3xl font-extrabold text-navy">${p.price}</div>
              <ul className="mt-5 space-y-2">
                {p.details.map((d) => <li key={d} className="flex items-start gap-2 text-sm text-slateBrand"><Check className="mt-0.5 h-4 w-4 shrink-0 text-successBrand" />{d}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-10 text-center text-sm text-slateBrand">Booking opens to H.E.A. Families in your dashboard. Galleries are delivered via external gallery links.</p>
      </section>
    </PublicLayout>
  );
}
